import { colors } from '@opallabs/spectrum'

export const baseStyles = ({ assetReference, borderRadius, size, style }) => ({
  borderRadius,
  display: 'inline-block',
  backgroundColor: assetReference ? 'none' : colors.orange.base,
  height: size,
  overflow: 'hidden',
  width: size,
  ...style,
})
